import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { trackPageView } from './utils/analytics';
import Homepage from './pages/homepage/Homepage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import OnboardingPage from './pages/OnboardingPage';
import DashboardPage from './pages/DashboardPage';
import ProgressPage from './pages/ProgressPage';
import ProfilePage from './pages/ProfilePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import DisclaimerPage from './pages/DisclaimerPage';
import HelpPage from './pages/HelpPage';
import TestPage from './pages/TestPage';
import DocumentsPage from './pages/DocumentsPage';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import ReportViewPage from './pages/ReportViewPage';
import CardioTrackingPage from './pages/CardioTrackingPage';
import AIDoctorPage from './pages/AIDoctorPage';
import CognitiveTaskPage from './pages/CognitiveTaskPage';
import PremiumPage from './pages/PremiumPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import AdminPage from './pages/AdminPage';
import UnutkanlikTestiPage from './pages/seo-tests/UnutkanlikTestiPage';
import DikkatTestiPage from './pages/seo-tests/DikkatTestiPage';
import KaygiTestiPage from './pages/seo-tests/KaygiTestiPage';
import UykuTestiPage from './pages/seo-tests/UykuTestiPage';
import StresTestiPage from './pages/seo-tests/StresTestiPage';
import ErkenUnutkanlikTestiPage from './pages/seo-tests/ErkenUnutkanlikTestiPage';
import OdaklanmaTestiPage from './pages/seo-tests/OdaklanmaTestiPage';
import SinavStresiTestiPage from './pages/seo-tests/SinavStresiTestiPage';
import DersVerimliTestiPage from './pages/seo-tests/DersVerimliTestiPage';
import SosyalAnksiyeteTestiPage from './pages/seo-tests/SosyalAnksiyeteTestiPage';
import PanikAtakTestiPage from './pages/seo-tests/PanikAtakTestiPage';
import DepresifBelirtilerTestiPage from './pages/seo-tests/DepresifBelirtilerTestiPage';
import InsomniaTestiPage from './pages/seo-tests/InsomniaTestiPage';
import UykuApnesiRiskiTestiPage from './pages/seo-tests/UykuApnesiRiskiTestiPage';
import YetiskindeDikkatTestiPage from './pages/seo-tests/YetiskindeDikkatTestiPage';
import KisaSureliHafizaTestiPage from './pages/seo-tests/KisaSureliHafizaTestiPage';
import KelimeBulmaTestiPage from './pages/seo-tests/KelimeBulmaTestiPage';
import KararVermeTestiPage from './pages/seo-tests/KararVermeTestiPage';
import BilisselEsneklikTestiPage from './pages/seo-tests/BilisselEsneklikTestiPage';
import SosyalMedyaBagimliligiTestiPage from './pages/seo-tests/SosyalMedyaBagimliligiTestiPage';
import TelefonBagimliligiTestiPage from './pages/seo-tests/TelefonBagimliligiTestiPage';
import MentalYorgunlukTestiPage from './pages/seo-tests/MentalYorgunlukTestiPage';
import MotivasyonTestiPage from './pages/seo-tests/MotivasyonTestiPage';
import YalnizlikTestiPage from './pages/seo-tests/YalnizlikTestiPage';
import OzguvenTestiPage from './pages/seo-tests/OzguvenTestiPage';
import OverthinkingTestiPage from './pages/seo-tests/OverthinkingTestiPage';
import YasamKalitesiTestiPage from './pages/seo-tests/YasamKalitesiTestiPage';
import StresYonetimiTestiPage from './pages/seo-tests/StresYonetimiTestiPage';
import DijitalDikkatTestiPage from './pages/seo-tests/DijitalDikkatTestiPage';
import SabahYorgunlukTestiPage from './pages/seo-tests/SabahYorgunlukTestiPage';
import KararsizlikTestiPage from './pages/seo-tests/KararsizlikTestiPage';
import IsStresiTestiPage from './pages/seo-tests/IsStresiTestiPage';
import IliskiStresiTestiPage from './pages/seo-tests/IliskiStresiTestiPage';
import GeceDusunmeTestiPage from './pages/seo-tests/GeceDusunmeTestiPage';
import DuygusalTukenmislikTestiPage from './pages/seo-tests/DuygusalTukenmislikTestiPage';
import DikkatSuresiTestiPage from './pages/seo-tests/DikkatSuresiTestiPage';
import SosyalKacinmaTestiPage from './pages/seo-tests/SosyalKacinmaTestiPage';
import GeceKaygiTestiPage from './pages/seo-tests/GeceKaygiTestiPage';
import IsKaygisiTestiPage from './pages/seo-tests/IsKaygisiTestiPage';
import SaglikAnksiyetesiTestiPage from './pages/seo-tests/SaglikAnksiyetesiTestiPage';
import PerformansKaygisiTestiPage from './pages/seo-tests/PerformansKaygisiTestiPage';
import UykuyaDalamamaTestiPage from './pages/seo-tests/UykuyaDalamamaTestiPage';
import GeceUyanmaTestiPage from './pages/seo-tests/GeceUyanmaTestiPage';
import UykuKalitesiTestiPage from './pages/seo-tests/UykuKalitesiTestiPage';
import BeyinYasiTestiPage from './pages/seo-tests/BeyinYasiTestiPage';
import ZihinselPerformansTestiPage from './pages/seo-tests/ZihinselPerformansTestiPage';
import KonsantrasyonKaybiTestiPage from './pages/seo-tests/KonsantrasyonKaybiTestiPage';
import AnksiyeteTestleriHub from './pages/seo-tests/AnksiyeteTestleriHub';
import UykuTestleriHub from './pages/seo-tests/UykuTestleriHub';
import HafizaBeyinTestleriHub from './pages/seo-tests/HafizaBeyinTestleriHub';
import DikkatOdakTestleriHub from './pages/seo-tests/DikkatOdakTestleriHub';
import StresTukenmislikTestleriHub from './pages/seo-tests/StresTukenmislikTestleriHub';
import OgrenciPerformansTestleriHub from './pages/seo-tests/OgrenciPerformansTestleriHub';
import YasamTarziTestleriHub from './pages/seo-tests/YasamTarziTestleriHub';
import TestlerPage from './pages/TestlerPage';
import BilimselDayanakPage from './pages/BilimselDayanakPage';
import HakkimizdaPage from './pages/HakkimizdaPage';
import IletisimPage from './pages/IletisimPage';
import './App.css';

/* GA4 route change tracker + scroll to top */
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <RouteTracker />
        <div className="app-root">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/testler" element={<TestlerPage />} />
          <Route path="/bilimsel-dayanak" element={<BilimselDayanakPage />} />
          <Route path="/hakkimizda" element={<HakkimizdaPage />} />
          <Route path="/iletisim" element={<IletisimPage />} />
          
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/progress"
            element={
              <ProtectedRoute>
                <ProgressPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test/:testId"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <ProtectedRoute>
                <DocumentsPage />
              </ProtectedRoute>
            }
          />
          <Route path="/report/:shareToken" element={<ReportViewPage />} />
          <Route
            path="/cardio"
            element={
              <ProtectedRoute>
                <CardioTrackingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-doctor"
            element={
              <ProtectedRoute>
                <AIDoctorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cognitive"
            element={
              <ProtectedRoute>
                <CognitiveTaskPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cognitive/:taskId"
            element={
              <ProtectedRoute>
                <CognitiveTaskPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/premium"
            element={
              <ProtectedRoute>
                <PremiumPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-success"
            element={
              <ProtectedRoute>
                <PaymentSuccessPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          
          {/* SEO Test Landing Pages — Public, no auth */}
          <Route path="/unutkanlik-testi" element={<UnutkanlikTestiPage />} />
          <Route path="/dikkat-testi" element={<DikkatTestiPage />} />
          <Route path="/kaygi-testi" element={<KaygiTestiPage />} />
          <Route path="/uyku-testi" element={<UykuTestiPage />} />
          <Route path="/stres-testi" element={<StresTestiPage />} />
          <Route path="/erken-unutkanlik-testi" element={<ErkenUnutkanlikTestiPage />} />
          <Route path="/odaklanma-testi" element={<OdaklanmaTestiPage />} />
          <Route path="/sinav-stresi-testi" element={<SinavStresiTestiPage />} />
          <Route path="/ders-verimliligi-testi" element={<DersVerimliTestiPage />} />
          <Route path="/sosyal-anksiyete-testi" element={<SosyalAnksiyeteTestiPage />} />
          <Route path="/panik-atak-testi" element={<PanikAtakTestiPage />} />
          <Route path="/depresif-belirtiler-testi" element={<DepresifBelirtilerTestiPage />} />
          <Route path="/insomnia-testi" element={<InsomniaTestiPage />} />
          <Route path="/uyku-apnesi-riski-testi" element={<UykuApnesiRiskiTestiPage />} />
          <Route path="/yetiskinde-dikkat-belirtileri-testi" element={<YetiskindeDikkatTestiPage />} />
          <Route path="/kisa-sureli-hafiza-belirtileri-testi" element={<KisaSureliHafizaTestiPage />} />
          <Route path="/kelime-bulma-guclugu-testi" element={<KelimeBulmaTestiPage />} />
          <Route path="/karar-verme-guclugu-testi" element={<KararVermeTestiPage />} />
          <Route path="/bilissel-esneklik-testi" element={<BilisselEsneklikTestiPage />} />
          <Route path="/sosyal-medya-bagimliligi-testi" element={<SosyalMedyaBagimliligiTestiPage />} />
          <Route path="/telefon-bagimliligi-testi" element={<TelefonBagimliligiTestiPage />} />
          <Route path="/mental-yorgunluk-testi" element={<MentalYorgunlukTestiPage />} />
          <Route path="/motivasyon-testi" element={<MotivasyonTestiPage />} />
          <Route path="/yalnizlik-testi" element={<YalnizlikTestiPage />} />
          <Route path="/ozguven-testi" element={<OzguvenTestiPage />} />
          <Route path="/overthinking-testi" element={<OverthinkingTestiPage />} />
          <Route path="/yasam-kalitesi-testi" element={<YasamKalitesiTestiPage />} />
          <Route path="/stres-yonetimi-testi" element={<StresYonetimiTestiPage />} />
          <Route path="/dijital-dikkat-daginikligi-testi" element={<DijitalDikkatTestiPage />} />
          <Route path="/sabah-yorgunluk-testi" element={<SabahYorgunlukTestiPage />} />
          <Route path="/kararsizlik-testi" element={<KararsizlikTestiPage />} />
          <Route path="/is-stresi-testi" element={<IsStresiTestiPage />} />
          <Route path="/iliski-stresi-testi" element={<IliskiStresiTestiPage />} />
          <Route path="/gece-dusunme-testi" element={<GeceDusunmeTestiPage />} />
          <Route path="/duygusal-tukenmislik-testi" element={<DuygusalTukenmislikTestiPage />} />
          <Route path="/dikkat-suresi-testi" element={<DikkatSuresiTestiPage />} />
          <Route path="/sosyal-kacinma-testi" element={<SosyalKacinmaTestiPage />} />
          <Route path="/gece-kaygi-testi" element={<GeceKaygiTestiPage />} />
          <Route path="/is-kaygisi-testi" element={<IsKaygisiTestiPage />} />
          <Route path="/saglik-anksiyetesi-testi" element={<SaglikAnksiyetesiTestiPage />} />
          <Route path="/performans-kaygisi-testi" element={<PerformansKaygisiTestiPage />} />
          <Route path="/uykuya-dalamama-testi" element={<UykuyaDalamamaTestiPage />} />
          <Route path="/gece-uyanma-testi" element={<GeceUyanmaTestiPage />} />
          <Route path="/uyku-kalitesi-testi" element={<UykuKalitesiTestiPage />} />
          <Route path="/beyin-yasi-testi" element={<BeyinYasiTestiPage />} />
          <Route path="/zihinsel-performans-testi" element={<ZihinselPerformansTestiPage />} />
          <Route path="/konsantrasyon-kaybi-testi" element={<KonsantrasyonKaybiTestiPage />} />
          {/* Cluster Hub Pages */}
          <Route path="/anksiyete-testleri" element={<AnksiyeteTestleriHub />} />
          <Route path="/uyku-testleri" element={<UykuTestleriHub />} />
          <Route path="/hafiza-ve-beyin-testleri" element={<HafizaBeyinTestleriHub />} />
          <Route path="/dikkat-ve-odak-testleri" element={<DikkatOdakTestleriHub />} />
          <Route path="/stres-ve-tukenmislik-testleri" element={<StresTukenmislikTestleriHub />} />
          <Route path="/ogrenci-performans-testleri" element={<OgrenciPerformansTestleriHub />} />
          <Route path="/yasam-tarzi-testleri" element={<YasamTarziTestleriHub />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
